import { EventrDate, IField, ValidationTypes } from '@eventr/common'
import {
    MobileDateRangePicker,
    useValidatorContext,
} from '@eventr/common-storybook'
import { useEffect, useMemo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { useEditSectionContext } from '../editSectionProvider'
interface IDateRangePickerFieldProps {
    field: IField
    _id?: string
}

export const DateRangePicker = ({ field, _id }: IDateRangePickerFieldProps) => {
    const { updateValues, values, getValue, isNewItem } =
        useEditSectionContext()
    const { isFieldValid } = useValidatorContext()
    const { getEventInfoV2 } = useBoundStore(
        useShallow((s) => {
            return {
                getEventInfoV2: s.getEventInfoV2,
            }
        })
    )
    const { getLanguageISO639Code } = useLanguageContext()

    const [isError, setIsError] = useState<boolean>(false)
    const [textError, setTextError] = useState<string>('')

    /// Validate onchange.
    useEffect(() => {
        try {
            const valid = isFieldValid(field, _id, getValue(field, _id), values)
            if ((valid !== true) !== isError) {
                setIsError(valid !== true)
            }
            if (valid !== true) {
                setTextError(valid as string)
            } else {
                setTextError('')
            }
        } catch {
            /// idk why it fails sometimes.
        }
    }, [
        field,
        _id,
        isFieldValid,
        setIsError,
        isError,
        setTextError,
        getValue,
        updateValues,
    ])

    const isRequired = useMemo(() => {
        return field.type_properties?.validations?.some(
            (v) => v.type === ValidationTypes.required
        )
    }, [field.type_properties?.validations])

    /// To limit the selection of the field.
    /// undifined will mean no limit.
    // function getMaxMinDateIfExists(
    //     validationType: ValidationTypes
    // ): EventrDate | undefined {
    //     try {
    //         var dateVaidationObject: IValidation =
    //             field.type_properties.validations.find((validationObject) => {
    //                 if (validationObject.type === validationType) {
    //                     return true
    //                 } else {
    //                     return false
    //                 }
    //             })

    //         if (dateVaidationObject) {
    //             const maxMinField = useBoundStore
    //                 .getState()
    //                 .getFieldById(dateVaidationObject.fieldValue)
    //             if (
    //                 values &&
    //                 maxMinField &&
    //                 values[maxMinField.type_properties.json_key]
    //             ) {
    //                 /// Works great IF is under the top level parent. ie values.
    //                 /// However, may be further down tree... idk how to deal with that...
    //                 const rangeDate = new EventrDate(
    //                     values[maxMinField.type_properties.json_key]
    //                 )
    //                 return rangeDate
    //             } else {
    //                 return undefined
    //             }
    //         } else {
    //             return undefined
    //         }
    //     } catch {
    //         return undefined
    //     }
    // }

    function handleSave(start: string, end: string) {
        /// clear tz.
        const tmpStart = new EventrDate(start).clearTimezone().dateTimeString
        const tmpEnd = new EventrDate(end).clearTimezone().dateTimeString

        updateValues({
            value: tmpStart,
            valueAlt: tmpEnd,
            field: field,
            _id: _id,
        })
    }

    function handleClear() {
        updateValues({
            value: undefined,
            valueAlt: undefined,
            field: field,
            _id: _id,
        })
    }

    return (
        <MobileDateRangePicker
            fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
            openTo={
                getValue(field, _id)
                    ? getValue(field, _id)
                    : _id === '0'
                    ? undefined
                    : isNewItem(_id)
                    ? undefined
                    : getEventInfoV2()?.data.start_date
            }
            startDateTimeString={getValue(field, _id)}
            endDateTimeString={getValue(field, _id, false, true)}
            onSave={handleSave}
            onClear={handleClear}
            language={getLanguageISO639Code()}
            translationString={{
                saveButton: i18n.t('general.done'),
                select: i18n.t('edit-itinerary.fields.select-date'),
            }}
            isError={isError}
            textError={textError}
            required={isRequired}
        />
    )
}
